import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { FeaturesBar } from "@/components/FeaturesBar";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { PriceGuide } from "@/components/PriceGuide";
import { Gallery } from "@/components/Gallery";
import { ServiceArea } from "@/components/ServiceArea";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <FeaturesBar />
        <Services />
        <WhyUs />
        <PriceGuide />
        <Gallery />
        <ServiceArea />
        <QuoteForm />
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
